var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 4H26C26.5304 4 27.0391 4.21071 27.4142 4.58579C27.7893 4.96086 28 5.46957 28 6V15.5155C26.5699 14.5583 24.8501 14 23 14C18.0294 14 14 18.0294 14 23C14 24.8501 14.5583 26.5699 15.5155 28H6C5.46957 28 4.96086 27.7893 4.58579 27.4142C4.21071 27.0391 4 26.5304 4 26V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H9V3C9 2.73478 9.10536 2.48043 9.29289 2.29289C9.48043 2.10536 9.73478 2 10 2C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V4H21V3C21 2.73478 21.1054 2.48043 21.2929 2.29289C21.4804 2.10536 21.7348 2 22 2C22.2652 2 22.5196 2.10536 22.7071 2.29289C22.8946 2.48043 23 2.73478 23 3V4ZM6 10H26V6H23V7C23 7.26522 22.8946 7.51957 22.7071 7.70711C22.5196 7.89464 22.2652 8 22 8C21.7348 8 21.4804 7.89464 21.2929 7.70711C21.1054 7.51957 21 7.26522 21 7V6H11V7C11 7.26522 10.8946 7.51957 10.7071 7.70711C10.5196 7.89464 10.2652 8 10 8C9.73478 8 9.48043 7.89464 9.29289 7.70711C9.10536 7.51957 9 7.26522 9 7V6H6V10Z",
    fill: "#686868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 16.7778C19.5636 16.7778 16.7778 19.5636 16.7778 23C16.7778 26.4364 19.5636 29.2222 23 29.2222C26.4364 29.2222 29.2222 26.4364 29.2222 23C29.2222 19.5636 26.4364 16.7778 23 16.7778ZM15 23C15 18.5817 18.5817 15 23 15C27.4183 15 31 18.5817 31 23C31 27.4183 27.4183 31 23 31C18.5817 31 15 27.4183 15 23Z",
    fill: "#686868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9 18C23.3971 18 23.8 18.4029 23.8 18.9V22.2H27.1C27.5971 22.2 28 22.6029 28 23.1C28 23.5971 27.5971 24 27.1 24H22.9C22.4029 24 22 23.5971 22 23.1V18.9C22 18.4029 22.4029 18 22.9 18Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlank);
export default __webpack_public_path__ + "static/media/CalendarBlank.da21cd69a54744858d83535be110211c.svg";
export { ForwardRef as ReactComponent };